namespace GeniuzPOS.Purchase {
    export namespace ListAppInvoiceReceiveService {
        export const baseUrl = 'Purchase/ListAppInvoiceReceive';

        export declare function Create(request: Serenity.SaveRequest<ListAppInvoiceReceiveRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ListAppInvoiceReceiveRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ListAppInvoiceReceiveRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ListAppInvoiceReceiveRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/ListAppInvoiceReceive/Create",
            Update = "Purchase/ListAppInvoiceReceive/Update",
            Delete = "Purchase/ListAppInvoiceReceive/Delete",
            Retrieve = "Purchase/ListAppInvoiceReceive/Retrieve",
            List = "Purchase/ListAppInvoiceReceive/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ListAppInvoiceReceiveService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
